import createVueComponent from '../createVueComponent';

const Beaker = createVueComponent('BeakerIcon', [
  ['path', { d: 'M4.5 3h15' }],
  ['path', { d: 'M6 3v16a2 2 0 002 2h8a2 2 0 002-2V3' }],
  ['path', { d: 'M6 14h12' }],
]);

export default Beaker;
